// Components
import Skeleton from '@mui/material/Skeleton';

// Styles
import styles from './index.module.sass';

export default function ItemDetail({ title, text, loading = false }) {
  return (
    <div className={styles.item}>
      <div className={styles.title}>{title}</div>
      {(loading && (
        <Skeleton variant='rectangular' animation='wave' className={styles.loadingText} />
      )) || <div className={styles.text}>{text}</div>}
    </div>
  );
}
